import ReactGA from 'react-ga4'
import TagManager from 'react-gtm-module'

import { LOCATION_CHANGE } from 'react-router-redux'
import { Dispatch, Middleware, MiddlewareAPI } from 'redux'
import { Plan } from '../../commons/Plan'
import { Referer } from '../../commons/Referer'
import rewriteMetaData from '../../commons/rewriteMetaTag'
import { notifyPurchaseToSlack } from '../../commons/slack'
import { POST_PAYMENT_SUCCESS, POST_SIGNUP_SUCCESS } from '../actions/authActions'
import { CREATE_QUESTION_SUCCESS, DELETE_QUESTION_SUCCESS, SHOW_QUIZ_START_MODAL } from '../actions/editorActions'
import metaDataList from '../meta'

const googleAnalyticsMiddleware: Middleware = ({ getState }: MiddlewareAPI) => (next: Dispatch) => action => {
  switch (action.type) {
    case LOCATION_CHANGE:
      const pathInfo = action.payload
      ReactGA.send({
        hitType: 'pageview',
        page: `${pathInfo.pathname}${pathInfo.search}`,
        title: `${document.title}`
      })
      // サボりましたすみません
      const metaInfo = metaDataList[pathInfo.pathname]
      if (metaInfo) {
        rewriteMetaData(metaInfo)
      }
      break

    case SHOW_QUIZ_START_MODAL().type:
      const label = 'show-url-modal'
      ReactGA.event({
        label,
        category: 'button',
        action: 'click'
      })
      break

    case POST_PAYMENT_SUCCESS().type:
      const {
        auth: { paymentPlan, currentUserId, paymentEventDate, paymentSelectedRefererOption, paymentOtherReferer }
      } = getState()

      const plan = Plan.info(paymentPlan)
      const referer = Referer.info(Number(paymentSelectedRefererOption))

      if (process.env.STAGE === 'production') {
        notifyPurchaseToSlack(
          '#purchased',
          currentUserId,
          plan.name,
          paymentEventDate,
          `${referer.name}${paymentOtherReferer ? `（${paymentOtherReferer}）` : ''}`
        )
      }

      TagManager.dataLayer({
        dataLayer: {
          plan: action.payload,
          event: 'payment_plan'
        }
      })

      ReactGA.event({
        label: 'payment-success',
        category: 'button',
        action: 'click'
      })
      break

    case POST_SIGNUP_SUCCESS().type:
      TagManager.dataLayer({
        dataLayer: {
          event: 'signup_organizer'
        }
      })

      ReactGA.event({
        label: 'signup-organizer',
        category: 'api-request',
        action: 'success'
      })
      break

    case CREATE_QUESTION_SUCCESS().type:
      ReactGA.event({
        label: 'add-question-slide',
        category: 'api-request',
        action: 'success'
      })
      break

    case DELETE_QUESTION_SUCCESS().type:
      ReactGA.event({
        label: 'delete-question-slide',
        category: 'api-request',
        action: 'success'
      })
      break
  }

  return next(action)
}

const createGoogleAnalyticsMiddleware = () => {
  return googleAnalyticsMiddleware
}
export default createGoogleAnalyticsMiddleware
